var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.4967C10.1536 13.4967 12.0572 13.6568 13.3994 14.0846C14.0682 14.2978 14.5395 14.5601 14.835 14.8502C15.1102 15.1207 15.25 15.43 15.25 15.8297C15.2499 16.2278 15.1101 16.5347 14.834 16.8033C14.5374 17.092 14.0644 17.3522 13.3936 17.5631C12.0474 17.9862 10.1428 18.1403 8 18.1403C5.84713 18.1403 3.9439 17.9801 2.60156 17.5524C1.93261 17.3392 1.46056 17.077 1.16504 16.7867C0.889745 16.5162 0.75 16.2068 0.75 15.8073C0.750112 15.4092 0.889937 15.1022 1.16602 14.8336C1.46261 14.545 1.93576 14.2857 2.60645 14.0748C3.95257 13.6517 5.85725 13.4967 8 13.4967ZM8 1.64026C10.6014 1.64026 12.5438 3.49567 12.5439 5.65198C12.5439 7.80856 10.6013 9.66467 8 9.66467C5.39956 9.66467 3.45605 7.80847 3.45605 5.65198C3.45619 3.49575 5.39946 1.64026 8 1.64026Z",
    stroke: "#5D5D5D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmp);
export default __webpack_public_path__ + "static/media/emp.86b4707300007a6e4207b80b4067e0a3.svg";
export { ForwardRef as ReactComponent };